import { render, staticRenderFns } from "./_accountListAlert.vue?vue&type=template&id=30aa99e0&lang=pug&"
import script from "./_accountListAlert.vue?vue&type=script&lang=js&"
export * from "./_accountListAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports